import { Injectable } from '@angular/core';
import { CustomerData } from '../models/customer-data';
import { CloudFunctionsService } from './cloud-functions.service';
import { v4 as uuidv4 } from 'uuid';
import { Orderinfo } from '../models/orderinfo';
import { AppConfigService } from './app-config.service';
import { LocaleService } from './locale.service';
import { CustomerAddress } from '../models/customer-address';
import { CurrentInfoService } from './current-info.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private customerData: CustomerData = new CustomerData();

  constructor(
    private cloudfunctionservice: CloudFunctionsService,
    private appconfigservice: AppConfigService,
    private localeservice: LocaleService,
    private currentinfoservice: CurrentInfoService
  ) {}

  public Initialize(customerData: any) {
    if (customerData !== null && customerData !== undefined) {
      Object.assign(this.customerData, customerData);

      this.customerData.setData(customerData);
    }
  }

  public hasCustomerData() {
    return (
      this.customerData !== null &&
      this.customerData !== undefined &&
      this.customerData.ID !== null &&
      this.customerData.ID !== undefined &&
      this.customerData.ID !== ''
    );
  }

  public async setCustomerData(data: { Name: string; Phone: string }) {
    this.customerData.Name = data.Name;
    this.customerData.Phone = data.Phone;
  }

  public async saveCustomerData() {
    try {
      if (this.customerData.ID.length === 0) this.customerData.ID = uuidv4();

      let result = await this.cloudfunctionservice.saveCustomerProfile(
        this.customerData
      );

      if (result === 'success') {
        localStorage.setItem('CustomerID', this.customerData.ID);

        return true;
      } else return false;
    } catch (error) {
      console.error(error);

      return false;
    }
  }

  public getCustomerData() {
    return this.customerData;
  }

  public getCustomerID() {
    var customerID = localStorage.getItem('CustomerID');

    if (customerID === null) customerID = '';

    return customerID;
  }

  public getCustomerName() {
    if (this.customerData) return String(this.customerData.Name);

    return '';
  }

  public getCustomerPhone() {
    if (this.customerData) return String(this.customerData.Phone);

    return '';
  }

  public async getOrderHistory() {
    if (this.customerData.ID !== null && this.customerData.ID !== undefined) {
      var orderhistory = new Array<Orderinfo>();

      var result = await this.cloudfunctionservice.getCustomerOrderHistory(
        this.customerData.ID
      );

      for (const key in result) {
        if (Object.prototype.hasOwnProperty.call(result, key)) {
          const element = result[key];
          var orderInfo = new Orderinfo();

          Object.assign(orderInfo, element);

          orderInfo.StatusString = this.GetStatusString(orderInfo.Status);

          orderhistory.push(orderInfo);
        }
      }

      var currentUnit = this.appconfigservice.getUnitID();

      return orderhistory
        .filter((orderInfo) => orderInfo.UnitID === currentUnit)
        .sort((n1, n2) => n2.Timestamp - n1.Timestamp);
    } else return new Array<Orderinfo>();
  }

  getCustomerAdressList() {
    return this.customerData.Adresses.filter(
      (x) => x.OriginID === this.currentinfoservice._currentInfo.PlaceID
    );
  }

  checkAdressName(oldAdressLocation: string, location: string) {
    if (oldAdressLocation === location) return true;

    var idx = this.customerData.Adresses.findIndex(
      (adress) => adress.Location === location
    );

    return idx > -1;
  }

  async saveCustomerAdress(adress: CustomerAddress) {
    try {
      this.customerData.Adresses.push(adress);

      var result = await this.cloudfunctionservice.saveCustomerProfile(
        this.customerData
      );

      return result === 'success';
    } catch (error) {
      return false;
    }
  }

  async deleteCustomerAdress(adress: CustomerAddress) {
    try {
      var idx = this.customerData.Adresses.findIndex(
        (x) => x.Location === adress.Location
      );

      if (idx > -1) {
        this.customerData.Adresses.splice(idx, 1);

        var result = await this.cloudfunctionservice.saveCustomerProfile(
          this.customerData
        );

        return result === 'success';
      } else return false;
    } catch (error) {
      return false;
    }
  }

  public GetStatusString(status: number) {
    switch (status) {
      case 0:
        return this.localeservice.instantTranslation('OrderStatus.Pending');
      case 1:
        return this.localeservice.instantTranslation('OrderStatus.Confirmed');
      case 2:
        return this.localeservice.instantTranslation('OrderStatus.Ready');
      case 3:
        return this.localeservice.instantTranslation('OrderStatus.OnTheWay');
      case 4:
        return this.localeservice.instantTranslation('OrderStatus.Finished');
      case 5:
        return this.localeservice.instantTranslation('OrderStatus.Canceled');
      default:
        return '?????';
    }
  }
}
